import { Link } from 'react-router-dom';
import TeamMembers from '../components/TeamMembers';
import ClientTestimonials from '../components/ClientTestimonials';
import VideoModal from '../components/VideoModal';

const AboutUs = () => {

  return (
    <>
      {/* Page Title */}
      <div className="page-title-area ptb-100">
        <div className="container">
          <div className="page-title-content">
            <h1>About Us</h1>
            <ul>
              <li className="item"><Link to="/">Home</Link></li>
              <li className="item"><Link to="/about"><i className="flaticon-play-button"></i>About Us</Link></li>
            </ul>
          </div>
        </div>
        <div className="bg-image">
          <img src="/assets/img/page-title/about-bg.jpg" alt="About Background" />
        </div>
      </div>

      {/* About Section */}
      <section id="about" className="about-section about-style-three pt-100 pb-70 bg-secondary">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="about-img-content">
                <div className="row">
                  <div className="col-lg-6 col-sm-6 col-6">
                    <div className="about-image">
                      <img src="/assets/img/about/about-img-4.jpg" alt="About" />
                    </div>
                    <div className="about-image">
                      <img src="/assets/img/about/about-img-5.jpg" alt="About" />
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-6 col-6">
                    <div className="about-image">
                      <img src="/assets/img/about/about-img-6.jpg" alt="About" />
                    </div>
                    <div className="about-image">
                      <img src="/assets/img/about/about-img-7.jpg" alt="About" />
                    </div>
                  </div>
                </div>
                <div className="overlay-content">
                  <h3>12+</h3>
                  <span>Years</span>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="about-content">
                <h2 className="color-secondary">We Build Everything As Your <span>Dream</span></h2>
                <p>Welcome to the dawn of a new era in luxury living and architectural excellence. Desale Patil, a renowned name in the realm of construction and development, proudly unveils its latest masterpiece: 'The Rising' As the sun sets on conventional standards, our 10-floor marvel ascends to redefine urban living, embodying innovation, sophistication, and a commitment to crafting spaces that transcend expectations.</p>
                <p>Join us on a journey where each floor tells a story of modern elegance, and together, we build dreams that touch the sky.</p>
                <div className="about-item-list">
                  <ul>
                    <li><i className="flaticon-play-button"></i> 100% Satisfaction Guarantee.</li>
                    <li><i className="flaticon-play-button"></i> Accurate Testing Processes.</li>
                    <li><i className="flaticon-play-button"></i> 12+ Years Of Experience.</li>
                    <li><i className="flaticon-play-button"></i> Strong Building Materials.</li>
                    <li><i className="flaticon-play-button"></i> Eco Friendly Build Materials.</li>
                  </ul>
                </div>
                <div className="cta-btn">
                  <Link to="/projects" className="primary-btn">Explore Projects</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Works Section */}
      <section className="our-works-section ptb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="works-content">
                <h2 className="color-secondary">See How We Manage Our <span>Works</span></h2>
                <p>At Desale Patil, we pride ourselves on our meticulous approach to managing our works, ensuring every project is executed with precision, efficiency, and excellence. Here's a glimpse into our methodology.</p>
                <div className="works-item">
                  <div className="works-item-single">
                    <i><img src="/assets/img/icons/architect.png" alt="Icon" /></i>
                    <div className="content">
                      <h4>Project <br /> Planning</h4>
                    </div>
                  </div>
                  <div className="works-item-single">
                    <i><img src="/assets/img/icons/plan.png" alt="Icon" /></i>
                    <div className="content">
                      <h4>General <br /> Contract</h4>
                    </div>
                  </div>
                  <div className="works-item-single">
                    <i><img src="/assets/img/icons/bridge.png" alt="Icon" /></i>
                    <div className="content">
                      <h4>Starting <br /> Project</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <VideoModal 
                videoSrc="/assets/img/Plan/dp.mp4"
                thumbnailSrc="/assets/img/b11.png"
              />
            </div>
          </div>
        </div>
      </section>

      {/* About Service Section */}
      <section className="about-services-section pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="service-item-single">
                <i><img src="/assets/img/icons/stairs.png" alt="Icon" /></i>
                <h3>Our Mission</h3>
                <p>Our mission to develop quality properties with realistic values for owners and joint venture partners.</p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="service-item-single">
                <i><img src="/assets/img/icons/saw-machine.png" alt="Icon" /></i>
                <h3>Our Vision</h3>
                <p>Our vision to continuously expand their role as leading developers in the construction industry.</p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="service-item-single">
                <i><img src="/assets/img/icons/helmet.png" alt="Icon" /></i>
                <h3>Our Expertise</h3>
                <p>Building Construction, Steel Plant Construction, Gabion Wall Construction, Painting & Tiling</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section - REMOVED (Using TeamMembers component below) */}

      {/* Team Members Component */}
      <TeamMembers />

      {/* Counter Section */}
      <section className="count-section pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="content">
                <h2><span className="counter">12</span>+</h2>
                <span>Years of Experience</span>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="content">
                <h2><span className="counter">100</span>+</h2>
                <span>Happy Clients</span>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="content">
                <h2><span className="counter">15</span>+</h2>
                <span>Work Employed</span>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="content">
                <h2><span className="counter">10</span>+</h2>
                <span>Project Completed</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="testimonial-section testimonial-two ptb-100 bg-primary">
        <div className="container">
          <div className="section-title style-two">
            <h2><span>Our</span> Satisfied Clients</h2>
          </div>
          <div className="row">
            <div className="col-lg-10 m-auto">
              <div className="testimonial-slider owl-carousel">
                <div className="slider-item">
                  <i className="flaticon-quotation-mark"></i>
                  <p>"Desale Patil exceeded our expectations in every aspect of our project. From the initial consultation to the final walk-through, their professionalism and attention to detail were remarkable. They delivered our dream home on time and within budget, and the quality of craftsmanship is truly exceptional. We couldn't be happier with the results and highly recommend Desale Patil to anyone seeking a reliable and trustworthy builder."</p>
                  <div className="client-img">
                    <img src="/assets/img/client/hd.jpg" alt="Client" />
                  </div>
                  <div className="client-info">
                    <h6>Hemant Dhondge</h6>
                    <span>Satisfied Investor</span>
                  </div>
                </div>
                <div className="slider-item">
                  <i className="flaticon-quotation-mark"></i>
                  <p>"As an investor, I've worked with several construction companies over the years, but none compare to Desale Patil. Their team's expertise, reliability, and dedication to excellence set them apart. They guided me through every step of the process, from site selection to project completion, and delivered outstanding results that have exceeded my expectations. I'm grateful for their professionalism and look forward to partnering with them on future projects."</p>
                  <div className="client-img">
                    <img src="/assets/img/client/rd.jpg" alt="Client" />
                  </div>
                  <div className="client-info">
                    <h6>Ritika Deore</h6>
                    <span>Happy Homeowners</span>
                  </div>
                </div>
                <div className="slider-item">
                  <i className="flaticon-quotation-mark"></i>
                  <p>"Choosing Desale Patil for our commercial development project was one of the best decisions we made. Their collaborative approach, coupled with their innovative designs and commitment to sustainability, resulted in a building that not only meets our business needs but also reflects our values as a company. The entire team at Desale Patil was a pleasure to work with, and their dedication to delivering excellence is truly commendable. We highly recommend them to anyone seeking a top-tier builder and developer."</p>
                  <div className="client-img">
                    <img src="/assets/img/client/gm.jpg" alt="Client" />
                  </div>
                  <div className="client-info">
                    <h6>Avinash Bangar</h6>
                    <span>CEO of Sharkey Logistics</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="newsletter-section newsletter-two bg-primary">
        <div className="container">
          <div className="content-container">
            <div className="row">
              <div className="col-lg-6">
                <div className="newsletter-content ptb-100">
                  <h2>DOWNLOAD OUR BROCHURE</h2>
                  <form className="newsletter-form">
                    <div className="input-group">
                      <input
                        className="form-control"
                        placeholder="Click On Download To Get PDF"
                        type="text"
                        readOnly
                      />
                      <div className="cta-btn">
                        <a className="primary-btn" target="_blank" href="/assets/dp.pdf" rel="noreferrer">
                          Download
                        </a>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Client Testimonials Section */}
      <ClientTestimonials />
    </>
  );
};

export default AboutUs;
